import { Link } from "react-router-dom";
import { Gift, X } from "lucide-react";
import { useState, useEffect } from "react";
import api from "@/lib/api";

const HIDE_KEY = "sl_referral_banner_hidden";

export default function ReferralBanner() {
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(HIDE_KEY) === "1");
  const [discount, setDiscount] = useState(5);

  useEffect(() => {
    api.get("/referral-config-public").then(({ data }) => {
      if (data?.discount_percent != null) setDiscount(data.discount_percent);
    }).catch(() => {});
  }, []);

  if (hidden) return null;

  const dismiss = () => {
    sessionStorage.setItem(HIDE_KEY, "1");
    setHidden(true);
  };

  return (
    <div
      className="mt-16 bg-white dark:bg-[color:var(--sl-card-bg)] border-b border-gray-200/70 dark:border-[color:var(--sl-border)] relative"
      data-testid="referral-banner"
    >
      <div className="max-w-6xl mx-auto flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1 pl-3 pr-9 py-2.5 sm:gap-x-3 sm:pl-4 sm:pr-10">
        <span
          className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-[#E89B1A] text-white grid place-items-center flex-shrink-0 shadow-sm"
          aria-hidden="true"
        >
          <Gift size={14} strokeWidth={2.5} className="sm:hidden" />
          <Gift size={16} strokeWidth={2.5} className="hidden sm:block" />
        </span>

        <div
          className="min-w-0 leading-tight text-center text-gray-800 dark:text-[color:var(--sl-text)]"
          style={{ fontSize: "12px" }}
          data-testid="referral-banner-text-ga_fr"
        >
          <span className="mr-1.5" aria-hidden="true">🇫🇷</span>
          <span className="font-medium sm:text-sm">Invitez un ami et faites-lui économiser</span>
          <span className="font-bold whitespace-nowrap sm:text-sm">
            <span className="ml-1.5 text-[#d17e10]">{discount} %</span>
            <span className="ml-1.5 hidden sm:inline text-gray-600 dark:text-[color:var(--sl-text)]/80 font-medium">sur ses frais (GA→FR / GA→RW)</span>
          </span>
        </div>

        <span data-testid="referral-banner-text-ga_rw" className="sr-only">
          Invitez un ami et faites-lui économiser {discount} % Gabon → Rwanda
        </span>

        <Link
          to="/parrainage"
          className="text-xs sm:text-sm font-bold text-[var(--sl-primary)] hover:underline underline-offset-2 whitespace-nowrap flex-shrink-0"
          data-testid="referral-banner-cta"
        >
          Obtenir mon code <span aria-hidden="true">→</span>
        </Link>
        <button
          onClick={dismiss}
          className="absolute right-1 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-white p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-white/10 transition-colors flex-shrink-0"
          aria-label="Masquer"
          data-testid="referral-banner-close"
        >
          <X size={15} />
        </button>
      </div>
    </div>
  );
}
